export default __webpack_public_path__ + "static/vishal-3adfec5c34d4e679da90020ace8c172f.jpg";